import styled from 'vue-styled-components';
import { square } from '@/styles/common.styled';
import {
    FLEX_COLUMN_DIV,
    FLEX_VERTICAL_CENTER_DIV,
    GRAY_100_SPAN,
} from '@/styles/common.styled.component';
import { DS } from './tokens';

export const Wrapper = styled(FLEX_COLUMN_DIV)`
    width: 100%;
    margin-top: 20px;
    padding-bottom: 40px;
`;

export const Title = styled(GRAY_100_SPAN)`
    font-size: 14px;
    font-weight: 500;
`;

export const Description = styled.p`
    font-size: 13px;
    color: ${DS['gray-80']};
    margin: 4px 0 12px 0;
`;

export const DropdownAnchor = styled(FLEX_COLUMN_DIV)`
    width: 100%;
    gap: 8px;
`;

// styled() can't wrap a foreign Vue component; use a plain container and
// override the SearchInput's own box via descendant selectors.
export const SearchInputWrapper = styled.div`
    width: 100%;

    .search-input {
        width: 100% !important;
    }
`;

// merges the old DropdownPanel border into the scrollable box itself.
// scroll style ported from React shared/ui/SearchableDropdown ListViewport.
export const ListViewport = styled('div', { isSearchEmpty: Boolean })`
    width: 100%;
    // the empty-search block is taller than the list cap, so lift it there
    max-height: ${({ isSearchEmpty }) => (isSearchEmpty ? 'none' : '228px')};
    overflow-y: auto;
    padding: 4px;
    background-color: ${DS['gray-white']};
    border: 1px solid ${DS['gray-40']};
    border-radius: 8px;

    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background: ${DS['gray-40']};
        border-radius: 100px;
    }

    scrollbar-width: thin;
    scrollbar-color: ${DS['gray-40']} transparent;
`;

export const LoaderWrapper = styled.div`
    width: 100%;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const EmptyText = styled(GRAY_100_SPAN)`
    display: block;
    width: 100%;
    padding: 16px 10px;
    font-size: 13px;
    color: ${DS['gray-70']};
    text-align: center;
`;

// ListViewport is content-box, so this is 10px short of the box height.
export const EmptySearchState = styled(FLEX_COLUMN_DIV)`
    min-height: 246px;
    align-items: center;
    justify-content: center;
    padding: 16px 10px;
    font-size: 13px;
    color: ${DS['gray-80']};
    text-align: center;

    > p {
        line-height: 19.5px;
    }
`;

export const Row = styled(FLEX_VERTICAL_CENTER_DIV, {
    isAutoAdd: Boolean,
    isSelected: Boolean,
    isIndeterminate: Boolean,
})`
    width: 100%;
    min-height: 36px;
    padding: 6px 10px;
    border-radius: 8px;
    gap: 8px;
    cursor: ${({ isAutoAdd }) => (isAutoAdd ? 'not-allowed' : 'pointer')};
    background-color: ${({ isSelected }) =>
        isSelected ? DS['blue-5'] : DS['gray-white']};

    &:hover {
        background-color: ${({ isAutoAdd, isSelected }) => {
            if (isAutoAdd) return DS['gray-white'];
            return isSelected ? DS['blue-5'] : DS['gray-10'];
        }};
    }

    .checkbox-wrapper {
        pointer-events: ${({ isAutoAdd }) => (isAutoAdd ? 'none' : 'auto')};
    }

    .checkbox-wrapper > div:first-child {
        ${square(14)};
        border-radius: 4px;
        background-color: ${({ isAutoAdd, isSelected, isIndeterminate }) => {
            if (isIndeterminate) return DS['blue-50'];
            if (isAutoAdd) return DS['blue-20'];
            return isSelected ? DS['blue-50'] : DS['gray-white'];
        }};
        border: ${({ isAutoAdd, isSelected, isIndeterminate }) =>
            isIndeterminate || isAutoAdd || isSelected
                ? 'none'
                : `1px solid ${DS['gray-40']}`};
    }

    &:hover .checkbox-wrapper > div:first-child {
        background-color: ${({ isAutoAdd, isSelected, isIndeterminate }) => {
            if (isIndeterminate) return DS['blue-50'];
            if (isAutoAdd) return DS['blue-20'];
            return isSelected ? DS['blue-60'] : DS['gray-5'];
        }};
        border: ${({ isAutoAdd, isSelected, isIndeterminate }) =>
            isIndeterminate || isAutoAdd || isSelected
                ? 'none'
                : `1px solid ${DS['blue-60']}`};
    }
`;

export const RowNameGroup = styled(FLEX_VERTICAL_CENTER_DIV)`
    gap: 4px;
    min-width: 0;
    overflow: hidden;
`;

export const RowName = styled.span`
    font-size: 14px;
    line-height: 21px;
    letter-spacing: -0.1px;
    color: ${DS['gray-100']};
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const AutoAddBadge = styled.span`
    display: inline-block;
    flex-shrink: 0;
    padding: 0 4px;
    border-radius: 4px;
    background-color: ${DS['blue-5']};
    color: ${DS['blue-50']};
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
    white-space: nowrap;
`;

export const RowMeta = styled(FLEX_VERTICAL_CENTER_DIV)`
    margin-left: auto;
    font-size: 12px;
    line-height: 18px;
    color: ${DS['gray-70']};
    white-space: nowrap;
`;
